import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { Container, PageHeader, Spinner } from "@/components/shared";
import { ArrowUpRight, Library } from "lucide-react";

const DOT = { green: "🟢", yellow: "🟡", red: "🔴" };
const CONF_LABEL = {
  green: "Consensus historique fort",
  yellow: "Sujet débattu entre chercheurs",
  red: "Hypothèse ou théorie minoritaire",
};

export default function Authors() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/afro/authors").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return <Container><Spinner label="Chargement des auteurs..." /></Container>;

  return (
    <Container className="max-w-5xl">
      <PageHeader eyebrow="Base documentaire" title="Auteurs & sources"
        subtitle="Les penseurs, historiens et institutions qui nourrissent les réponses de BIZARRE AI. Chaque fiche distingue faits, débats et hypothèses." />

      <div className="flex flex-wrap gap-4 mb-8 text-xs text-white/50" data-testid="authors-legend">
        {Object.entries(CONF_LABEL).map(([k, v]) => (
          <span key={k} className="inline-flex items-center gap-1.5">{DOT[k]} {v}</span>
        ))}
      </div>

      {data.categories.map((cat) => {
        const list = data.by_category[cat] || [];
        if (!list.length) return null;
        return (
          <section key={cat} className="mb-10" data-testid={`authors-cat-${cat}`}>
            <h2 className="font-display text-lg md:text-xl text-white/85 mb-4 flex items-center gap-2">
              <Library size={18} className="text-gold" /> {cat}
            </h2>
            <div className="grid sm:grid-cols-2 gap-3">
              {list.map((a) => (
                <motion.div key={a.slug} whileHover={{ y: -3 }} transition={{ type: "spring", stiffness: 400, damping: 22 }}>
                  <Link to={`/auteurs/${a.slug}`} data-testid={`author-card-${a.slug}`}
                    className="group block card-surface p-4 hover:border-gold/40 transition-colors h-full">
                    <div className="flex items-start justify-between gap-2 mb-1">
                      <p className="font-display text-base gold-text leading-tight">{a.name}</p>
                      <span className="text-sm shrink-0" title={CONF_LABEL[a.confidence]}>{DOT[a.confidence]}</span>
                    </div>
                    <p className="text-white/40 text-[11px] mb-2">{a.dates} · {a.domain}</p>
                    <p className="text-white/60 text-sm leading-relaxed line-clamp-3">{a.bio}</p>
                    <span className="inline-flex items-center gap-1 text-gold text-xs font-medium mt-3 group-hover:gap-2 transition-all">
                      Voir la fiche <ArrowUpRight size={13} />
                    </span>
                  </Link>
                </motion.div>
              ))}
            </div>
          </section>
        );
      })}
    </Container>
  );
}
